import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// constants
import {  RadioActionTypes } from './constants';
import { SagaIterator } from 'redux-saga';
import { APICore } from '../../helpers/api/apiCore';
import { API_ENDPOINTS } from '../../frameWork/utils/keyapi-endpoints';
import { changeDashboardChartsAction } from '../dashboardPageData/actions';
import { isUndefined } from 'lodash';
import { changeRadiosGetAction, changeRadiosGetSuccessAction } from './actions';

const api = new APICore();


/**
 * Toggle the class on body
 * @param {*} cssClass
 */


/**
 * ---------------------------------------------------------------------------------------------------------------------------
 * Note: Following are the functions which allows you to save the user prefrences on backend side by making an api request.
 * For now, we are just applying the required logic on frontend side
 * ----------------------------------------------------------------------------------------------------------------------------
 */

/**
 * Show the rightsidebar
 */

const getRadioListRequestAsync = async (Id: any) => {
  try {
    let url: string = "";

    url = `${API_ENDPOINTS.RADIO}`;


    const { data } = await api.get(url, null);    
    if (data.data)
      return data.data
    else {
      if (data.statusCode === 'UnAuthorized')
        return { "message": { title: 'UnAuthorized', message: '' } }
      else
        if (data.statusCode === 'ExpireTimeLink')
          return { "message": { title: 'ExpireTimeLink', message: data?.message } }
        else
          return data
    }
  }
  catch (e) {
    return { "message": e }
  };
}

function* getRadioListItems({ payload }: any): SagaIterator {

  try {
    yield put(changeRadiosGetAction());
    const response = yield call(getRadioListRequestAsync, payload);      
    yield put(changeRadiosGetSuccessAction(response));
    //yield put(changeDashboardChartsAction(response));
  } catch (error) {
    //yield put(getRadiobuttonListError(error));
  }
}



export function* watchGetList(): any {
  yield takeEvery(RadioActionTypes.Radiobutton_GET_LIST, getRadioListItems);
}




function* RadioSaga(): any {
  yield all([fork(watchGetList)]);
}

export default RadioSaga;
